export const technos = [
  {
    name: "symfony",
    img: "./images/techno/symfony_black_.svg",
  },
  {
    name: "javascript",
    img: "./images/techno/js.svg",
  },

  {
    name: "bootsctrap",
    img: "./images/techno/bootstrap.png",
  },
  {
    name: "react",
    img: "./images/techno/react.png",
  },
  {
    name: "node",
    img: "./images/techno/nodejs.png",
  },
  {
    name: "vuejs",
    img: "./images/techno/vuejs.png",
  },
  {
    name: "php",
    img: "./images/techno/php.png",
  },
  {
    name: "c++",
    img: "./images/techno/c++.png",
  },
  {
    name: "python#",
    img: "./images/techno/pyton.png",
  },
  {
    name: "laravel",
    img: "./images/techno/laravel.svg",
  },
  {
    name: "sass",
    img: "./images/techno/sass.png",
  },
  {
    name: "java",
    img: "./images/techno/java.png",
  },
  {
    name: "typescript#",
    img: "./images/techno/ts.png",
  },
];
